import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Expand, Minimize } from '@sweep-io/sweep-design/dist/icons';
import { useCallback } from 'react';
import { AI_AGENTS_EVENTS } from '../../services/events';
import useAgentsHome from './useAgentsHome';
import useSendBiEvent from '../../hooks/useSendBiEvent';

const ToggleExpandButton = () => {
  const { isExpanded, toggleIsExpanded, closeAllPanels } = useAgentsHome();
  const sendBiEvent = useSendBiEvent();

  const handleToggleClick = useCallback(() => {
    if (isExpanded) {
      //going to collapse
      closeAllPanels();
    } else {
      //going to expand
      sendBiEvent({ name: AI_AGENTS_EVENTS.expand });
    }
    toggleIsExpanded();
  }, [closeAllPanels, isExpanded, sendBiEvent, toggleIsExpanded]);

  return (
    <Tooltip placement="top" title={isExpanded ? 'Collapse' : 'Expand'}>
      <span>
        <IconButton variant="flat" onClick={handleToggleClick} size="small">
          {isExpanded ? <Minimize /> : <Expand />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ToggleExpandButton;
